import { render, staticRenderFns } from "./AttributeFilter.vue?vue&type=template&id=885b5bb2"
import script from "./AttributeFilter.vue?vue&type=script&lang=ts"
export * from "./AttributeFilter.vue?vue&type=script&lang=ts"
import style0 from "./AttributeFilter.vue?vue&type=style&index=0&id=885b5bb2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports